
// import React, { useState, useRef, useEffect } from 'react';
// import { postData, getData, serverURL } from '../../../../Services/Fetchnodeservices';
// import { Image as ImageIcon, Sparkles, X, Plus, CloudUpload, History, ListCheck } from 'lucide-react';
// import ImageSearchModal from './ImageSearchModal';

// const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded, preSelectedServerImage }) => {
//     const [step, setStep] = useState('select-source');
//     const [loadingStep, setLoadingStep] = useState("");
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [serverFileName, setServerFileName] = useState("");
//     const [previewUrl, setPreviewUrl] = useState("");
//     const [scanResults, setScanResults] = useState([]);
//     const [vendorImages, setVendorImages] = useState([]);
//     const [loadingImages, setLoadingImages] = useState(false);
//     const [saving, setSaving] = useState(false);
//     const [isBulkSearching, setIsBulkSearching] = useState(false);
//     const [showImageFinder, setShowImageFinder] = useState(false);
//     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const fileInputRef = useRef(null);

//     useEffect(() => {
//         if (isOpen) {
//             if (preSelectedServerImage) {
//                 setServerFileName(preSelectedServerImage);
//                 setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
//                 setStep('upload');
//             } else {
//                 setStep('select-source');
//                 setServerFileName("");
//                 setSelectedFile(null);
//                 setPreviewUrl("");
//             }
//             setScanResults([]);
//         }
//     }, [isOpen, preSelectedServerImage]);

//     // ✅ AI price is MENU price → customer = menu * 1.2
//     const computePrices = (menuPrice) => {
//         const m = parseFloat(menuPrice) || 0;
//         const cust = Math.round(m * 1.20);
//         return { menu: m, cust, comm: cust - m };
//     };
//     const computeVariantPrice = (menuPrice) => Math.round((parseFloat(menuPrice) || 0) * 1.20);

//     const autoFetchAllImages = async () => {
//         setIsBulkSearching(true);
//         const updated = [...scanResults];
//         for (let i = 0; i < updated.length; i++) {
//             try {
//                 setLoadingStep(`✨ Finding image for: ${updated[i].name}...`);
//                 const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
//                 if (resp.success && resp.images.length > 0) {
//                     updated[i].pic1 = resp.images[0].url;
//                     setScanResults([...updated]);
//                 }
//             } catch (e) { console.error(e); }
//         }
//         setIsBulkSearching(false);
//         setLoadingStep("");
//     };

//     const fetchVendorImages = async () => {
//         setLoadingImages(true);
//         setStep('vendor-images');
//         try {
//             const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
//             if (resp.success) {
//                 const allFiles = [];
//                 resp.data.forEach(req => {
//                     const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
//                     files.forEach(f => {
//                         if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
//                     });
//                 });
//                 setVendorImages(allFiles);
//             }
//         } catch (e) { console.error(e); }
//         finally { setLoadingImages(false); }
//     };

//     const handleVendorImageSelect = (filename) => {
//         setServerFileName(filename);
//         setPreviewUrl(`${serverURL}/uploads/${filename}`);
//         setStep('upload');
//     };

//     const startScan = async () => {
//         setStep('scanning');
//         setLoadingStep("🧠 AI is reading the menu...");
//         const formData = new FormData();
//         if (selectedFile) formData.append("file", selectedFile);
//         else formData.append("serverFileName", serverFileName);
//         formData.append("designation_id", designationId);
//         formData.append("instructions", "Extract item names, prices, variants, veg/non-veg, and a short description.");

//         try {
//             const resp = await postData("aimenu/ai-scan", formData);
//             if (resp.success) {
//                 setScanResults(resp.new_items.map(i => ({
//                     ...i,
//                     tempId: Math.random().toString(36).substr(2, 9),
//                     selected: true,
//                     variants: i.variants?.map(v => ({ ...v, price: v.price || v.item_price_variant })) || [],
//                     description: i.description || ""
//                 })));
//                 setStep('results');
//             } else { setStep('select-source'); }
//         } catch (err) { setStep('select-source'); }
//     };

//     const handleSaveItems = async () => {
//         setSaving(true);
//         const finalItems = scanResults.filter(i => i.selected).map(item => {
//             const menuPrice = parseFloat(item.price) || 0;
//             const p = computePrices(menuPrice);

//             const formattedVariants = (item.variants || []).map(v => {
//                 const variantMenu = parseFloat(v.price) || 0;
//                 return {
//                     unit: (v.unit_value || "Price").toLowerCase(),
//                     unit_value: v.unit_value || "Price",
//                     actual_price: variantMenu,                           // menu price
//                     item_price_variant: computeVariantPrice(variantMenu), // customer price
//                     is_available_variant: "yes"
//                 };
//             });

//             return {
//                 ...item,
//                 requested_price: p.menu,   // menu price
//                 price: p.cust,             // customer price
//                 status: "1",
//                 source: "ai_scan",
//                 variant: formattedVariants,
//                 description: item.description || ""
//             };
//         });

//         try {
//             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
//             if (resp.success) { onItemsAdded(); onClose(); }
//         } catch (e) { console.error(e); }
//         finally { setSaving(false); }
//     };

//     const handleImageSelect = (imgUrl) => {
//         if (currentSearchIndex !== null) {
//             setScanResults(prev => {
//                 const updated = [...prev];
//                 if (updated[currentSearchIndex]) {
//                     updated[currentSearchIndex].pic1 = imgUrl;
//                 }
//                 return updated;
//             });
//         }
//         setShowImageFinder(false);
//     };

//     if (!isOpen) return null;

//     return (
//         <div style={styles.overlay} onClick={showImageFinder ? undefined : onClose}>
//             <div style={styles.modal} onClick={e => e.stopPropagation()}>
//                 <div style={styles.header}>
//                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
//                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
//                         <h3 style={{margin:0, fontSize:'18px'}}>🤖 AI Scanner – {restaurantName}</h3>
//                     </div>
//                     {scanResults.length > 0 && (
//                         <div style={styles.countBadge}>
//                             <ListCheck size={14} /> {scanResults.length} items
//                         </div>
//                     )}
//                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
//                 </div>

//                 <div style={styles.body}>
//                     {step === 'select-source' ? (
//                         <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
//                             <div style={styles.sourceCard} onClick={() => setStep('upload')}>
//                                 <CloudUpload size={40} color="#a855f7" />
//                                 <h3 style={{color:'white'}}>Upload File</h3>
//                                 <p style={{color:'#94a3b8'}}>From your device</p>
//                             </div>
//                             <div style={styles.sourceCard} onClick={fetchVendorImages}>
//                                 <History size={40} color="#3b82f6" />
//                                 <h3 style={{color:'white'}}>Vendor Menu</h3>
//                                 <p style={{color:'#94a3b8'}}>Previously uploaded</p>
//                             </div>
//                         </div>
//                     ) : step === 'vendor-images' ? (
//                         <div>
//                             <button onClick={()=>setStep('select-source')} style={styles.backBtn}>← Back</button>
//                             {loadingImages ? <div className="loader"></div> : (
//                                 <div style={styles.grid}>
//                                     {vendorImages.map((img, i) => (
//                                         <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
//                                             <img src={`${serverURL}/uploads/${img.name}`} alt="menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
//                                             <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     ) : step === 'upload' ? (
//                         <div style={{textAlign:'center'}}>
//                             <button onClick={()=>setStep('select-source')} style={styles.backBtnLeft}>← Change</button>
//                             <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
//                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
//                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
//                             </div>
//                             <button style={styles.btnPrimary} onClick={startScan}>🔍 Start AI Scan</button>
//                         </div>
//                     ) : (step === 'scanning' || isBulkSearching) ? (
//                         <div style={{textAlign:'center', padding:'80px'}}>
//                             <div className="loader"></div>
//                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
//                         </div>
//                     ) : (
//                         <>
//                             <div style={{display:'flex', gap:'10px', marginBottom:'20px', alignItems:'center', justifyContent:'space-between'}}>
//                                 <div style={{display:'flex', gap:'10px'}}>
//                                     <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "💾 Add Items"}</button>
//                                     <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> ✨ Auto Images</button>
//                                 </div>
//                                 <div style={{color:'#94a3b8', fontSize:'14px', fontWeight:600}}>{scanResults.length} items</div>
//                             </div>
//                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
//                                 {scanResults.map((item, idx) => (
//                                     <div key={item.tempId} style={styles.itemCard}>
//                                         <div style={{display:'flex', gap:'15px'}}>
//                                             <div style={{width:'110px', textAlign:'center'}}>
//                                                 <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.thumb} onError={e=>e.target.src="https://via.placeholder.com/100"} alt="dish" />
//                                                 <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Better Image</button>
//                                             </div>
//                                             <div style={{flex:1}}>
//                                                 <div style={{display:'flex', gap:'10px'}}>
//                                                     <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
//                                                     <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
//                                                 </div>
//                                                 <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />
                                                
//                                                 <div style={styles.variantBox}>
//                                                     <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
//                                                         {item.variants.map((v, vIdx) => (
//                                                             <div key={vIdx} style={styles.vRow}>
//                                                                 <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
//                                                                 <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
//                                                                 <span style={{color:'#10b981', fontSize:'11px'}}>₹{computeVariantPrice(v.price)}</span>
//                                                                 <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={styles.delBtn}><X size={12}/></button>
//                                                             </div>
//                                                         ))}
//                                                         <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0}); setScanResults(nr)}}>+ Price</button>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>

//             {showImageFinder && (
//                 <div onClick={e => e.stopPropagation()} style={{ position: 'relative', zIndex: 10000 }}>
//                     <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={handleImageSelect} />
//                 </div>
//             )}
//             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
//         </div>
//     );
// };

// const styles = {
//     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
//     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
//     countBadge: { background: '#a855f722', color: '#a855f7', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' },
//     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
//     body: { flex: 1, overflowY: 'auto', padding: '20px' },
//     backBtn: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', fontWeight:600 },
//     backBtnLeft: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left', fontWeight:600 },
//     sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
//     grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
//     imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
//     imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
//     dropZone: { height: '220px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow:'hidden', clear:'both' },
//     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
//     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
//     thumb: { width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover', border:'1px solid #1f1f1f' },
//     findBtn: { width:'100%', background: '#a855f722', border: 'none', color: '#a855f7', fontSize: '10px', padding: '6px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', fontWeight:600 },
//     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '18px', fontWeight: 700, flex: 1, outline: 'none' },
//     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '12px', padding: '10px', marginTop: '10px', resize: 'none', outline: 'none', minHeight:'50px' },
//     variantBox: { background: '#161616', padding: '10px', borderRadius: '8px', marginTop: '10px' },
//     vRow: { display: 'flex', alignItems: 'center', gap: '8px', background: '#0a0a0a', padding: '5px 10px', borderRadius: '6px', border: '1px solid #1f1f1f' },
//     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '70px', fontSize: '12px', fontWeight: 'bold', outline: 'none' },
//     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '60px', padding: '4px', textAlign: 'center', fontSize: '12px', outline: 'none' },
//     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
//     btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight:600 },
//     addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '11px', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight:600 },
//     delBtn: { background:'none', border:'none', color:'#f87171', cursor:'pointer' },
//     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '5px', fontSize: '12px' },
//     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// };

// export default AIScanModal;

import React, { useState, useRef, useEffect } from 'react';
import { postData, getData, serverURL } from '../../../../Services/Fetchnodeservices';
import { Image as ImageIcon, Sparkles, X, Plus, CloudUpload, History, ListCheck } from 'lucide-react';
import ImageSearchModal from './ImageSearchModal';

const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded, preSelectedServerImage }) => {
    const [step, setStep] = useState('select-source');
    const [loadingStep, setLoadingStep] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [serverFileName, setServerFileName] = useState("");
    const [previewUrl, setPreviewUrl] = useState("");
    const [scanResults, setScanResults] = useState([]);
    const [vendorImages, setVendorImages] = useState([]);
    const [loadingImages, setLoadingImages] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isBulkSearching, setIsBulkSearching] = useState(false);
    const [showImageFinder, setShowImageFinder] = useState(false);
    const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            if (preSelectedServerImage) {
                setServerFileName(preSelectedServerImage);
                setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
                setStep('upload');
            } else {
                setStep('select-source');
                setServerFileName("");
                setSelectedFile(null);
                setPreviewUrl("");
            }
            setScanResults([]);
        }
    }, [isOpen, preSelectedServerImage]);

    // ✅ AI price is MENU price → customer = menu * 1.2
    const computePrices = (menuPrice) => {
        const m = parseFloat(menuPrice) || 0;
        const cust = Math.round(m * 1.20);
        return { menu: m, cust, comm: cust - m };
    };
    const computeVariantPrice = (menuPrice) => Math.round((parseFloat(menuPrice) || 0) * 1.20);

    const autoFetchAllImages = async () => {
        setIsBulkSearching(true);
        const updated = [...scanResults];
        for (let i = 0; i < updated.length; i++) {
            try {
                setLoadingStep(`✨ Finding image for: ${updated[i].name}...`);
                const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
                if (resp.success && resp.images.length > 0) {
                    updated[i].pic1 = resp.images[0].url;
                    setScanResults([...updated]);
                }
            } catch (e) { console.error(e); }
        }
        setIsBulkSearching(false);
        setLoadingStep("");
    };

    const fetchVendorImages = async () => {
        setLoadingImages(true);
        setStep('vendor-images');
        try {
            const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
            if (resp.success) {
                const allFiles = [];
                resp.data.forEach(req => {
                    const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
                    files.forEach(f => {
                        if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
                    });
                });
                setVendorImages(allFiles);
            }
        } catch (e) { console.error(e); }
        finally { setLoadingImages(false); }
    };

    const handleVendorImageSelect = (filename) => {
        setServerFileName(filename);
        setPreviewUrl(`${serverURL}/uploads/${filename}`);
        setStep('upload');
    };

    const startScan = async () => {
        setStep('scanning');
        setLoadingStep("🧠 AI is reading the menu...");
        const formData = new FormData();
        if (selectedFile) formData.append("file", selectedFile);
        else formData.append("serverFileName", serverFileName);
        formData.append("designation_id", designationId);
        formData.append("instructions", "Extract item names, prices, variants, veg/non-veg, and a short description.");

        try {
            const resp = await postData("aimenu/ai-scan", formData);
            if (resp.success) {
                setScanResults(resp.new_items.map(i => ({
                    ...i,
                    tempId: Math.random().toString(36).substr(2, 9),
                    selected: true,
                    // keep the base price as-is; it's the item's single/main price
                    price: i.price || 0,
                    variants: i.variants?.map(v => ({ ...v, price: v.price || v.item_price_variant })) || [],
                    description: i.description || ""
                })));
                setStep('results');
            } else { setStep('select-source'); }
        } catch (err) { setStep('select-source'); }
    };

    const handleSaveItems = async () => {
        setSaving(true);
        const finalItems = scanResults.filter(i => i.selected).map(item => {
            const menuPrice = parseFloat(item.price) || 0;
            const p = computePrices(menuPrice);

            const formattedVariants = (item.variants || []).map(v => {
                const variantMenu = parseFloat(v.price) || 0;
                return {
                    unit: (v.unit_value || "Price").toLowerCase(),
                    unit_value: v.unit_value || "Price",
                    actual_price: variantMenu,                           // menu price
                    item_price_variant: computeVariantPrice(variantMenu), // customer price
                    is_available_variant: "yes"
                };
            });

            return {
                ...item,
                requested_price: p.menu,   // menu price
                price: p.cust,             // customer price
                status: "1",
                source: "ai_scan",
                variant: formattedVariants,
                description: item.description || ""
            };
        });

        try {
            const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
            if (resp.success) { onItemsAdded(); onClose(); }
        } catch (e) { console.error(e); }
        finally { setSaving(false); }
    };

    const handleImageSelect = (imgUrl) => {
        if (currentSearchIndex !== null) {
            setScanResults(prev => {
                const updated = [...prev];
                if (updated[currentSearchIndex]) {
                    updated[currentSearchIndex].pic1 = imgUrl;
                }
                return updated;
            });
        }
        setShowImageFinder(false);
    };

    if (!isOpen) return null;

    return (
        <div style={styles.overlay} onClick={showImageFinder ? undefined : onClose}>
            <div style={styles.modal} onClick={e => e.stopPropagation()}>
                <div style={styles.header}>
                    <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
                        <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
                        <h3 style={{margin:0, fontSize:'18px'}}>🤖 AI Scanner – {restaurantName}</h3>
                    </div>
                    {scanResults.length > 0 && (
                        <div style={styles.countBadge}>
                            <ListCheck size={14} /> {scanResults.length} items
                        </div>
                    )}
                    <button onClick={onClose} style={styles.closeBtn}><X /></button>
                </div>

                <div style={styles.body}>
                    {step === 'select-source' ? (
                        <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
                            <div style={styles.sourceCard} onClick={() => setStep('upload')}>
                                <CloudUpload size={40} color="#a855f7" />
                                <h3 style={{color:'white'}}>Upload File</h3>
                                <p style={{color:'#94a3b8'}}>From your device</p>
                            </div>
                            <div style={styles.sourceCard} onClick={fetchVendorImages}>
                                <History size={40} color="#3b82f6" />
                                <h3 style={{color:'white'}}>Vendor Menu</h3>
                                <p style={{color:'#94a3b8'}}>Previously uploaded</p>
                            </div>
                        </div>
                    ) : step === 'vendor-images' ? (
                        <div>
                            <button onClick={()=>setStep('select-source')} style={styles.backBtn}>← Back</button>
                            {loadingImages ? <div className="loader"></div> : (
                                <div style={styles.grid}>
                                    {vendorImages.map((img, i) => (
                                        <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
                                            <img src={`${serverURL}/uploads/${img.name}`} alt="menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
                                            <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ) : step === 'upload' ? (
                        <div style={{textAlign:'center'}}>
                            <button onClick={()=>setStep('select-source')} style={styles.backBtnLeft}>← Change</button>
                            <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
                                <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
                                {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
                            </div>
                            <button style={styles.btnPrimary} onClick={startScan}>🔍 Start AI Scan</button>
                        </div>
                    ) : (step === 'scanning' || isBulkSearching) ? (
                        <div style={{textAlign:'center', padding:'80px'}}>
                            <div className="loader"></div>
                            <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
                        </div>
                    ) : (
                        <>
                            <div style={{display:'flex', gap:'10px', marginBottom:'20px', alignItems:'center', justifyContent:'space-between'}}>
                                <div style={{display:'flex', gap:'10px'}}>
                                    <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "💾 Add Items"}</button>
                                    <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> ✨ Auto Images</button>
                                </div>
                                <div style={{color:'#94a3b8', fontSize:'14px', fontWeight:600}}>{scanResults.length} items</div>
                            </div>
                            <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
                                {scanResults.map((item, idx) => (
                                    <div key={item.tempId} style={styles.itemCard}>
                                        <div style={{display:'flex', gap:'15px'}}>
                                            <div style={{width:'110px', textAlign:'center'}}>
                                                <img
                                                    src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`}
                                                    style={styles.thumb}
                                                    onError={e => { e.target.onerror = null; e.target.src = "https://placehold.co/100x100?text=No+Image"; }}
                                                    alt="dish"
                                                />
                                                <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Better Image</button>
                                            </div>
                                            <div style={{flex:1}}>
                                                <div style={{display:'flex', gap:'10px'}}>
                                                    <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
                                                    <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
                                                </div>

                                                {/* ─── MAIN FIX ───────────────────────────────────────────
                                                    Base/main price (item.price) was extracted correctly by
                                                    the backend but was never rendered in the UI for items
                                                    that have no variants (single-price items like on the
                                                    "Urban Slice" style menu). Only the variants list was
                                                    shown, so single-price items always looked "empty".
                                                    This input makes the base price always visible/editable,
                                                    regardless of whether variants exist. */}
                                                <div style={styles.basePriceRow}>
                                                    <span style={styles.basePriceLabel}>Base Price ₹</span>
                                                    <input
                                                        type="number"
                                                        style={styles.inputPrice}
                                                        value={item.price}
                                                        onChange={e => { const nr=[...scanResults]; nr[idx].price = e.target.value; setScanResults(nr); }}
                                                    />
                                                    <span style={{color:'#10b981', fontSize:'11px'}}>Customer: ₹{computeVariantPrice(item.price)}</span>
                                                    {(!item.price || item.price === 0) && (
                                                        <span style={styles.priceWarning}>⚠ No price found — please check manually</span>
                                                    )}
                                                </div>

                                                <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />

                                                <div style={styles.variantBox}>
                                                    <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
                                                        {item.variants.map((v, vIdx) => (
                                                            <div key={vIdx} style={styles.vRow}>
                                                                <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
                                                                <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
                                                                <span style={{color:'#10b981', fontSize:'11px'}}>₹{computeVariantPrice(v.price)}</span>
                                                                <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={styles.delBtn}><X size={12}/></button>
                                                            </div>
                                                        ))}
                                                        <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0}); setScanResults(nr)}}>+ Price</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            {showImageFinder && (
                <div onClick={e => e.stopPropagation()} style={{ position: 'relative', zIndex: 10000 }}>
                    <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={handleImageSelect} />
                </div>
            )}
            <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
        </div>
    );
};

const styles = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
    countBadge: { background: '#a855f722', color: '#a855f7', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' },
    aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
    body: { flex: 1, overflowY: 'auto', padding: '20px' },
    backBtn: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', fontWeight:600 },
    backBtnLeft: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left', fontWeight:600 },
    sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
    grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
    imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
    imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
    dropZone: { height: '220px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow:'hidden', clear:'both' },
    btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
    itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
    thumb: { width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover', border:'1px solid #1f1f1f' },
    findBtn: { width:'100%', background: '#a855f722', border: 'none', color: '#a855f7', fontSize: '10px', padding: '6px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', fontWeight:600 },
    inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '18px', fontWeight: 700, flex: 1, outline: 'none' },
    basePriceRow: { display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', background: '#161616', border: '1px solid #334155', borderRadius: '8px', padding: '8px 10px', flexWrap: 'wrap' },
    basePriceLabel: { color: '#a855f7', fontSize: '12px', fontWeight: 700 },
    priceWarning: { color: '#f59e0b', fontSize: '11px', fontWeight: 600 },
    inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '12px', padding: '10px', marginTop: '10px', resize: 'none', outline: 'none', minHeight:'50px' },
    variantBox: { background: '#161616', padding: '10px', borderRadius: '8px', marginTop: '10px' },
    vRow: { display: 'flex', alignItems: 'center', gap: '8px', background: '#0a0a0a', padding: '5px 10px', borderRadius: '6px', border: '1px solid #1f1f1f' },
    inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '70px', fontSize: '12px', fontWeight: 'bold', outline: 'none' },
    inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '60px', padding: '4px', textAlign: 'center', fontSize: '12px', outline: 'none' },
    btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
    btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight:600 },
    addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '11px', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight:600 },
    delBtn: { background:'none', border:'none', color:'#f87171', cursor:'pointer' },
    typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '5px', fontSize: '12px' },
    closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
};

export default AIScanModal;